// Entry point for the build script in your package.json
import "."
//= require jquery3
//= require popper
//= require bootstrap

import '@ant-design/v5-patch-for-react-19';

import { unstableSetRender } from 'antd';
import { createRoot } from 'react-dom/client';

import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.mjs`;
unstableSetRender((node, container) => {
  container._reactRoot ||= createRoot(container);
  const root = container._reactRoot;
  root.render(node);
  return async () => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    root.unmount();
  };
});

// app/javascript/application.js (host or engine)
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()